module.exports = __webpack_public_path__ + "static/media/task_icon.086633a9.jpg";